import { useEffect, useRef } from 'react';
import isEqual from 'lodash/isEqual';

/**
 * Like useEffect, but the dependency array is compared by deep value equality
 * (lodash isEqual) instead of Object.is reference identity. Use for deps that are
 * objects/arrays rebuilt every render but semantically unchanged.
 *
 * In-place mutation of a dep (same object reference) is not detected — pass a new
 * reference on change, same as useEffect.
 *
 * @param {import('react').EffectCallback} effect
 * @param {import('react').DependencyList} deps
 */
export const useDeepCompareEffect = (effect, deps) => {
  const ref = useRef(undefined);

  if (!isEqual(deps, ref.current)) {
    ref.current = deps;
  }

  // ref.current keeps the same identity while deps stay deep-equal, so useEffect
  // re-runs exactly on deep-value change, not on reference change.
  // eslint-disable-next-line react-hooks/exhaustive-deps
  useEffect(effect, ref.current);
};
